import RevenueAndShare from '../components/RevenueAndShare/RevenueAndShare'
import Step2 from '../components/RevenueAndShare/Step2'
import RegistrationCompletion from '../components/RevenueAndShare/RegistrationCompletion'
import InvitationCode from '../components/RevenueAndShare/InvitationCode'
import RevenueShareDetail from '../components/RevenueAndShare/RevenueShareDetail'
import ApprovalComplete from '../components/RevenueAndShare/ApprovalComplete'
import Detail from '../components/RevenueAndShare/Detail'
import RevenueShareIndex from '../components/RevenueAndShare/RevenueShareIndex'
import CollaboratorDetail from '../components/RevenueAndShare/CollaboratorDetail'
import Step2Album from '../components/RevenueAndShare/Step2Album'
import DetailForAlbum from '../components/RevenueAndShare/DetailForAlbum'
import CollaboratorDetailForAlbum from '../components/RevenueAndShare/CollaboratorDetailForAlbum'
import CollaboratorRevenueShareCancel from '../components/RevenueAndShare/CollaboratorRevenueShareCancel'

export default [
  {
    path: '/client/split',
    name: 'revenue-share',
    component: RevenueShareIndex,
    meta: {
      sideMenuId: 'revenue-share',
    },
  },
  {
    path: '/client/revenue-share/step-1',
    name: 'revenue-share-step-1',
    component: RevenueAndShare,
    meta: {
      sideMenuId: 'revenue-share',
    },
  },
  {
    path: '/client/revenue-share/album/step-2/:id',
    name: 'revenue-share-album-step-2',
    component: Step2Album,
    meta: {
      sideMenuId: 'revenue-share',
    },
  },
  {
    path: '/client/revenue-share/step-2/:id',
    name: 'revenue-share-step-2',
    component: Step2,
    meta: {
      sideMenuId: 'revenue-share',
    },
  },
  {
    path: '/client/revenue-share/registration-completion',
    name: 'revenue-share-registration-completion',
    component: RegistrationCompletion,
    meta: {
      sideMenuId: 'revenue-share',
    },
  },
  {
    path: '/client/revenue-share/invitation-code',
    name: 'revenue-share-invitation-code',
    component: InvitationCode,
    meta: {
      sideMenuId: 'revenue-share',
    },
  },
  {
    path: '/client/revenue-share/confirm-revenue-share/:pId/:rId',
    name: 'revenue-share-confirm-revenue-share',
    component: RevenueShareDetail,
    meta: {
      sideMenuId: 'revenue-share',
    },
  },
  {
    path: '/client/revenue-share/detail/:id',
    name: 'revenue-share-detail',
    component: Detail,
    meta: {
      sideMenuId: 'revenue-share',
    },
  },
  {
    path: '/client/revenue-share/detail/album/:id',
    name: 'revenue-share-album-detail',
    component: DetailForAlbum,
    meta: {
      sideMenuId: 'revenue-share',
    },
  },
  {
    path: '/client/revenue-share-collaborator/detail/album/:id',
    name: 'revenue-share-album-collaborator-detail',
    component: CollaboratorDetailForAlbum,
    meta: {
      sideMenuId: 'revenue-share',
    },
  },
  {
    path: '/client/revenue-share-collaborator/detail/:id',
    name: 'revenue-share-collaborator-detail',
    component: CollaboratorDetail,
    meta: {
      sideMenuId: 'revenue-share',
    },
  },
  {
    path: '/client/revenue-share/approval-complete',
    name: 'revenue-share-approval-complete',
    component: ApprovalComplete,
    meta: {
      sideMenuId: 'revenue-share',
    },
  },
  {
    path: '/client/revenue-share/cancel',
    name: 'revenue-share-cancel',
    component: CollaboratorRevenueShareCancel,
    meta: {
      sideMenuId: 'revenue-share',
    },
  },
]
